export const STOCKROOM_MODE_NORMAL = 'Normal';
export const STOCKROOM_MODE_MASTER = 'Master';
export const STOCKROOM_MODE_POU = 'POU';
export const NEW_STOCKROOM = 'CREATE_NEW_STOCKROOM';
export const CLONE_STOCKROOM = 'CLONE_EXISTING_STOCKROOM';

export const NEW_STOCKROOM_NAME_MAX = 100;
export const NEW_STOCKROOM_COMMENT_MAX_WORDS = 500;

export const NEW_STOCKROOM_MODES = [
    { value: STOCKROOM_MODE_NORMAL, label: 'Master/Normal Stockroom' },
    { value: STOCKROOM_MODE_POU, label: 'POU Stockroom' },
];

export const REQUEST_TYPES = [
    { value: NEW_STOCKROOM, label: 'Create New Stockroom' },
    { value: CLONE_STOCKROOM, label: 'Clone Existing Stockroom' },
];